import { CheckCircle2, AlertCircle, Info, Lightbulb, Sparkles } from "lucide-react";
import { SectionHeading } from "./ResultsPrimitives";

const PRIORITY = {
  high: "error", alta: "error", crítica: "error",
  medium: "warning", media: "warning",
  low: "success", baja: "success",
};
const TONE = {
  error: { border: "#F43F5E", badge: "vt-badge vt-badge-error" },
  warning: { border: "#F59E0B", badge: "vt-badge vt-badge-warning" },
  success: { border: "#10B981", badge: "vt-badge vt-badge-success" },
};

export function KeyInsights({ summary }) {
  return (
    <section data-testid="key-insights-section">
      <SectionHeading eyebrow="Nivel 3" title="Insights clave" icon={Sparkles} accent="magenta" />
      <div className="mt-4 grid md:grid-cols-2 gap-3">
        {summary.strengths?.map((item) => (
          <div key={`strength-${item.substring(0, 30)}`} className="vt-card bg-brand-card p-4 flex items-start gap-3">
            <span className="w-8 h-8 rounded-lg bg-emerald-500/10 border border-emerald-400/30 text-emerald-300 flex items-center justify-center shrink-0"><CheckCircle2 className="w-4 h-4" /></span>
            <div><p className="text-[11px] font-bold uppercase tracking-widest text-emerald-300/80 mb-0.5">Fortaleza</p><p className="text-sm text-brand-text2">{item}</p></div>
          </div>
        ))}
        {summary.weaknesses?.map((item) => (
          <div key={`weakness-${item.substring(0, 30)}`} className="vt-card bg-brand-card p-4 flex items-start gap-3">
            <span className="w-8 h-8 rounded-lg bg-rose-500/10 border border-rose-400/30 text-rose-300 flex items-center justify-center shrink-0"><AlertCircle className="w-4 h-4" /></span>
            <div><p className="text-[11px] font-bold uppercase tracking-widest text-rose-300/80 mb-0.5">Debilidad</p><p className="text-sm text-brand-text2">{item}</p></div>
          </div>
        ))}
      </div>

      {summary.priority_actions && (
        <div className="mt-4 vt-card bg-brand-card p-5">
          <h4 className="font-bold text-vt-ink mb-3 flex items-center gap-2"><Info className="w-4 h-4 text-cyan-300" />Acciones Prioritarias:</h4>
          <div className="space-y-2">
            {summary.priority_actions.map((action, actionIndex) => (
              <div key={`action-${actionIndex}`} className="rounded-xl bg-brand-elevated/60 border border-white/10 p-3 border-l-2 border-l-cyan-400">
                <div className="flex items-center justify-between gap-3 mb-1">
                  <span className="font-semibold text-sm text-vt-ink">{action.action}</span>
                  <span className="vt-badge vt-badge-success shrink-0">{action.estimated_impact}</span>
                </div>
                <span className="text-xs text-brand-muted">Esfuerzo: {action.effort}</span>
              </div>
            ))}
          </div>
          {summary.estimated_total_improvement && (
            <div className="mt-5 text-center">
              <div className="vt-score text-4xl font-extrabold vt-gradient-text-cool inline-block">{summary.estimated_total_improvement}</div>
              <div className="text-sm text-brand-muted">Mejora Total Estimada</div>
            </div>
          )}
        </div>
      )}
    </section>
  );
}

export function Recommendations({ items }) {
  return (
    <section>
      <SectionHeading eyebrow="Nivel 3" title="Recomendaciones" icon={Lightbulb} accent="violet" />
      <div data-testid="recommendations-section" className="mt-4 grid md:grid-cols-2 gap-3">
        {items.map((rec, index) => {
          const t = TONE[PRIORITY[rec.priority] || "warning"];
          return (
            <div key={index} className="vt-card bg-brand-card p-4 border-l-2" style={{ borderLeftColor: t.border }}>
              <div className="flex items-center justify-between gap-2 mb-2">
                <span className="text-[11px] font-bold uppercase tracking-widest text-purple-300">{rec.category}</span>
                <span className={t.badge}>{rec.priority}</span>
              </div>
              <p className="text-sm text-vt-ink mb-2">{rec.suggestion}</p>
              <p className="text-xs text-brand-text2"><strong className="text-cyan-300">Impacto:</strong> {rec.expected_impact}</p>
            </div>
          );
        })}
      </div>
    </section>
  );
}
